import ApplicationModel, { attr } from '../ApplicationModel';
import { type BookmarksNowNextLaterRoadmapAttributes } from './generated/BookmarksNowNextLaterRoadmapAttributes';
import { model } from '../modelBuilder';
import CardLayout from './CardLayout';

interface BookmarksNowNextLaterRoadmap
  extends BookmarksNowNextLaterRoadmapAttributes {}

@model
class BookmarksNowNextLaterRoadmap extends ApplicationModel {
  // Start auto-generated
  static typename: 'BookmarksNowNextLaterRoadmap' =
    'BookmarksNowNextLaterRoadmap';
  get typename(): 'BookmarksNowNextLaterRoadmap' {
    return 'BookmarksNowNextLaterRoadmap';
  }

  static internalTypename: 'Bookmarks::NowNextLaterRoadmap' =
    'Bookmarks::NowNextLaterRoadmap';
  get internalTypename(): 'Bookmarks::NowNextLaterRoadmap' {
    return 'Bookmarks::NowNextLaterRoadmap';
  }

  static bookmarkName = 'Bookmarks::NowNextLaterRoadmap';

  static inputType = 'NowNextLaterRoadmapAttributes!';

  static fields = {
    advancedFilters: attr({ writable: true, readable: true }),
    advancedFiltersParsed: attr({ writable: true, readable: true, json: true }),
    createdAt: attr({ readable: true }),
    dateField: attr({ writable: true, readable: true }),
    dateFieldAccessors: attr({ readable: true }),
    filters: attr({ writable: true, readable: true }),
    groupBy: attr({ writable: true, readable: true }),
    groupByCustomFieldDefinitionId: attr({ writable: true, readable: false }),
    id: attr({ readable: true }),
    projectId: attr({ readable: true }),
    recordType: attr({ writable: true, readable: true }),
    showCollapsedView: attr({ writable: true, readable: true }),
    showDates: attr({ writable: true, readable: true }),
    showDescription: attr({ writable: true, readable: true }),
    timeframe: attr({ writable: true, readable: true }),
    title: attr({ writable: true, readable: true }),
    updatedAt: attr({ readable: true }),
    cardLayout: attr.belongsTo({
      writeShape: [
        'epicRecordLayout',
        'featureRecordLayout',
        'ideaRecordLayout',
        'initiativeRecordLayout',
        'releaseRecordLayout',
        'releasePhaseRecordLayout',
        'requirementRecordLayout',
        'taskRecordLayout',
        'goalRecordLayout',
      ],
      readable: true,
      typename: 'CardLayout',
    }),
    defaultCardLayout: attr.belongsTo({
      readable: true,
      typename: 'CardLayout',
    }),
    groupByCustomFieldDefinition: attr.belongsTo({
      readable: true,
      typename: 'CustomFieldDefinition',
    }),
    laterPane: attr.belongsTo({
      writeShape: [
        'title',
        'description',
        'timeframe',
        'sortBy',
        'startDate',
        'endDate',
        'daysFromToday',
      ],
      readable: true,
      typename: 'BookmarksNowNextLaterPane',
    }),
    nextPane: attr.belongsTo({
      writeShape: [
        'title',
        'description',
        'timeframe',
        'sortBy',
        'startDate',
        'endDate',
        'daysFromToday',
      ],
      readable: true,
      typename: 'BookmarksNowNextLaterPane',
    }),
    nowPane: attr.belongsTo({
      writeShape: [
        'title',
        'description',
        'timeframe',
        'sortBy',
        'startDate',
        'endDate',
        'daysFromToday',
      ],
      readable: true,
      typename: 'BookmarksNowNextLaterPane',
    }),
    permissions: attr.belongsTo({
      readable: true,
      typename: 'ResourcePermissions',
    }),
    project: attr.belongsTo({ readable: true, typename: 'Project' }),
    records: attr.hasMany({
      args: {
        publishableId: 'ID',
        publishableType: 'String',
        viewSnapshotId: 'ID',
        dashboardId: 'ID',
        exportType: 'String',
        sharedFilterConfiguration: 'JSON',
        dashboardFilterConfiguration: 'JSON',
      },
      readable: true,
    }),
  };
  // End auto-generated

  get activeCardLayout() {
    const { cardLayout, defaultCardLayout } = this;

    if (cardLayout && defaultCardLayout) {
      return CardLayout.buildActiveCardLayout({
        cardLayout,
        defaultCardLayout,
        cardViews: ['expanded'],
      });
    }
  }
}

export default BookmarksNowNextLaterRoadmap;
